import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListItemPriceListsRequest extends IBaseRequest {
    baseOnly?:   string;
    type?:       string;
    name?:       string;
    exactMatch?: string;
}

export class ListItemPriceListsRequest extends BaseRequest implements IListItemPriceListsRequest {
    public baseOnly?:   string;
    public type?:       string;
    public name?:       string;
    public exactMatch?: string;

    constructor(server: string, session: string, otherOptions: any) {
        super(server, session);
        this.baseOnly   = otherOptions.baseOnly;
        this.type       = otherOptions.type;
        this.name       = otherOptions.name;
        this.exactMatch = otherOptions.exactMatch;
    }

    public toXml(): string {
        var parameters: string = super.toXml();

        parameters += this.makeNode(this.baseOnly, 'baseOnly');
        parameters += this.makeNode(this.type, 'type');
        parameters += this.makeNode(this.name, 'name');
        parameters += this.makeNode(this.exactMatch, 'exactMatch');
        
        return super.wrapperXml('ListItemPriceLists', parameters);
    }
}
